var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"visible-icon"},[_c('i',{staticClass:"fe-eye text-muted",attrs:{"id":_vm.iconId}}),_c('b-tooltip',{attrs:{"target":_vm.iconId,"triggers":"hover","custom-class":"tooltip-white"}},[_vm._v(" "+_vm._s(_vm.$t('common.visibleField'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }